import type { ReactNode } from 'react';
import styled from 'styled-components';
import { SizeSpacing32 } from 'autogen/design-tokens/global/tokens';

export type ContentRendererProps = {
    children: ReactNode;
};

const ContentContainer = styled.div`
    display: flex;
    padding: ${SizeSpacing32};
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
    flex-direction: column;
`;

const DefaultContent = ({ children }: ContentRendererProps) => {
    return <ContentContainer>{children}</ContentContainer>;
};

const ContentContainerNoPadding = styled(ContentContainer)`
    padding: 0;
`;

const DefaultContentNoPadding = ({ children }: ContentRendererProps) => {
    return <ContentContainerNoPadding>{children}</ContentContainerNoPadding>;
};

const DefaultContentRenderer = Object.assign(DefaultContent, { NoPadding: DefaultContentNoPadding });

export default DefaultContentRenderer;
